import React, { useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import Dropdown from 'components/Dropdown'
import { Button } from '@nexiahome/ui-common/components/primitives/buttons'

import AlertIconWithCount from 'pages/shared/Alert/IconWithCount'

import { Customer } from 'types/Customer'

import { color } from 'styles/colors'
import styled from 'styled-components'

 type Props = {
  customersWithoutLocation: Array<Customer>
  className?: string
}

const CustomersWithoutAddressesDropdown = ({ customersWithoutLocation, className } : Props) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const navigate = useNavigate()
  const button = useRef<HTMLButtonElement>(null)

  const sortedCustomersWithAlertsCount = customersWithoutLocation.map((customer) => {
    let totalCriticalAlertCount = 0
    let totalMajorAlertCount = 0
    let totalSdaMajorAlertCount = 0
    customer.devices.forEach((device) => {
      totalCriticalAlertCount += (device.criticalAlertCount || 0)
      totalMajorAlertCount += (device.majorAlertCount || 0)
      totalSdaMajorAlertCount += (device.sdaMajorAlertCount || 0)
    })

    return {
      ...customer,
      criticalAlertCount: totalCriticalAlertCount,
      majorAlertCount: totalMajorAlertCount,
      sdaMajorAlertCount: totalSdaMajorAlertCount
    }
  }).sort((a, b) => (b.criticalAlertCount + b.majorAlertCount + b.sdaMajorAlertCount) - (a.criticalAlertCount + a.majorAlertCount + a.sdaMajorAlertCount))

  return (
    <div className={className}>
      <S.Button
        ref={button}
        onMouseOver={() => setIsDropdownOpen((isOpen) => !isOpen)}
        aria-controls="1"
        aria-haspopup
      >
        {customersWithoutLocation.length} {customersWithoutLocation.length > 1 ? ' customers' : ' customer'}
      </S.Button>
      {customersWithoutLocation.length > 1
        ? 'have alerts but no valid address'
        : 'has alerts but no valid address'
            }
      <Dropdown isOpen={isDropdownOpen} onClose={(event) => { if (event?.target !== button.current) setIsDropdownOpen(false) }}>
        <S.List>
          {sortedCustomersWithAlertsCount.slice(0, 10).map((customer) => {
            return (
              <S.MenuItem key={customer.id}>
                <S.AlertWrapper>
                  <S.Name href={`/customers/${customer.id}`} data-route data-testid="customer-link">
                    {customer.firstName} {customer.lastName}
                  </S.Name>
                  <AlertIconWithCount severity="critical" count={customer.criticalAlertCount} data-testid="criticalAlertCount" />
                  <AlertIconWithCount severity="major" count={customer.majorAlertCount} data-testid="majorAlertCount" />
                  <AlertIconWithCount severity="major-sda" count={customer.sdaMajorAlertCount} data-testid="sdaMajorAlertCount" />
                </S.AlertWrapper>
                <Button decoration="secondary" text="EDIT" onPress={() => navigate(`/customers/${customer.id}/edit`)} />
              </S.MenuItem>
            )
          })
          }
          {customersWithoutLocation.length > 10 &&
          <S.InfoMessage>* Only the top 10 customers without coordinates are displayed.</S.InfoMessage>
          }
        </S.List>
      </Dropdown>
    </div>
  )
}

export default CustomersWithoutAddressesDropdown

const S = {
  List: styled.div`
    background-color: ${color('paneBackground')};
    margin-left: -3px;
  `,
  MenuItem: styled.li`
    display: block;
    padding: 10px 15px;
    color: ${color('tooltipText')};
    border-bottom: 1px solid ${color('divider')};
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  DeviceId: styled.a`
    padding-right: 10px;
  `,
  Device: styled.div`
    margin-top: 10px;
  `,
  Name: styled.a`
    font-size: 15px;
    margin-bottom: 10px;
    margin-right: 10px;
  `,
  AlertWrapper: styled.div`
    display: flex;
    margin-right: 10px;
  `,
  InfoMessage: styled.div`
    padding: 0px 10px 0px 10px;
  `,
  Button: styled.button`
    color: ${color('migrateDealerSpinner')};
    font-weight: bold;
    outline: none;
    padding-right: 4px;
  `
}
